import { render, staticRenderFns } from "./briefTrainingReportCountry_represent.vue?vue&type=template&id=2a324cd4&scoped=true"
import script from "./briefTrainingReportCountry_represent.vue?vue&type=script&lang=js"
export * from "./briefTrainingReportCountry_represent.vue?vue&type=script&lang=js"
import style0 from "./briefTrainingReportCountry_represent.vue?vue&type=style&index=0&id=2a324cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a324cd4",
  null
  
)

export default component.exports